<template>
  <div>
    <!-- 顶部搜索 -->
    <div class="search-box">
      <input type="text" placeholder="请搜索型号或者相关信息" />
      <div class="icon">
        <img src="../assets/images/tabbar/sousuohei@2x.png" alt  />
      </div>
      <span @click="$router.push('/searchResult')">搜索</span>
    </div>
    <!-- 分类区域 -->
    <div class="category">
      <!-- left nav -->
      <div class="left-nav" ref="letNav">
        <ul>
          <li
            v-for="(item,index) in categoryName"
            :key="index"
            :class="{'active' : current == index}"
            @click="changeList(index)"
          >{{item}}</li>
        </ul>
      </div>
      <!-- 右侧 -->
      <div class="right-nav-wrap">
        <div class="right-nav" v-show="current == index" v-for="(item,index) in category" :key="index" ref="rightItem">
          <!-- title -->
          <p class="title">{{item.name}}</p>
          <div class="content">
            <ul>
              <li v-for="(children,index) in item.childrens" :key="index" @click="toSearch(children)">{{children.name}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { category } from "../request/api";
import { constants } from "crypto";
export default {
  name: "category",
  data() {
    return {
      current: 0,
      categoryName: [],
      category: []
    };
  },
  created() {
    this.getCategory();
  },
  methods: {
    changeList(index) {
      this.current = index;
    },
    getCategory() {
      category({}).then(res => {
        this.category = res.data;
        this.category.forEach(el => {
          this.categoryName.push(el.name);
        });
      });
    },
    toSearch(children){
      this.$router.push({
        name:'searchResult',
        params:{
          categoryName:children.name
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.search-box {
  width: 100%;
  height: 90px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  position: sticky;
  top: 0;
  font-size: 30px;
  z-index: 99;
  background: #fff;
  border-bottom: 1px solid #f2f2f2;
  input {
    width: 613px;
    height: 72px;
    line-height: 72px;
    background: #f5f5f5;
    border-radius: 8px;
    padding-left: 70px;
    box-sizing: border-box;
    border: solid 1px #dcdcdc;
    margin-right: 15px;
    margin-left: 30px;
  }
  .icon {
    position: absolute;
    left: 47px;
    top: 28px;
    width: 36px;
    height:36px;
    img{
      width: 100%;
      height:100%;
    }
  }
  span {
    color: #333;
  }
}
.category {
  overflow: hidden;
  padding-top: 5px;
  display: flex;
}
// 左侧
.left-nav {
  top: 100px;
  left: 0;
  height: calc(100% - 200px);
  overflow-y: scroll;
  position: fixed;
  ul {
    border-right: 1px solid #f2f2f2;
    li {
      width: 176px;
      height: 106px;
      background: #f5f5f5;
      border-bottom: 1px solid #e6e6e6;
      text-align: center;
      line-height: 106px;
      font-size: 26px;
      color: #333;
      overflow: hidden;
    }
    .active {
      background: #fff;
      color: #2f80ec;
    }
  }
}
// 右侧
.right-nav-wrap {
  width: calc(100% - 208px);
  height: 1250px;
  overflow-y: scroll;
  margin-left: 200px;
  margin-bottom: 150px;
}
.right-nav {
  .title {
    color: #2f80ec;
    font-size: 24px;
    padding: 40px 0 30px 0;
  }
  .content {
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 165px;
        height: 54px;
        line-height: 54px;
        text-align: center;
        background: #f7f8fa;
        color: #666;
        font-size: 24px;
        margin: 0 10px 20px 0;
        border-radius: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>